var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "document-summary" },
    [
      _c("h5", { staticClass: "section-title" }, [
        _vm._v("📄 Resumen del Documento")
      ]),
      _c("b-card", { staticClass: "summary-card" }, [
        _c("div", { staticClass: "summary-content" }, [
          _c("div", { staticClass: "summary-icon" }, [
            _vm._v(_vm._s(_vm.icon))
          ]),
          _c("div", { staticClass: "summary-details" }, [
            _c("div", { staticClass: "summary-row" }, [
              _c("strong", [_vm._v("Tipo:")]),
              _vm._v(" " + _vm._s(_vm.type.text) + " "),
              _c("span", { staticClass: "text-muted" }, [
                _vm._v("(" + _vm._s(_vm.type.value) + ")")
              ])
            ]),
            _vm.description
              ? _c("div", { staticClass: "summary-row" }, [
                  _c("strong", [_vm._v("Descripción:")]),
                  _vm._v(" " + _vm._s(_vm.description) + " ")
                ])
              : _vm._e()
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }